<!-- [selectedIndex]="_selectedIndex"  -->

<div class="setup-header">
  <h3>
    {{'Record an Action' | translate | async}}
  </h3>
</div>
<mat-horizontal-stepper linear="true" #stepper (selectionChange)="stepChangedManually($event)"
  [selectedIndex]="_selectedIndex">
  <mat-step>
    <ng-template matStepLabel>{{   "Select Equipment" | translate | async  }}</ng-template>

    <div class="panel panel--components" style="width:40%;  margin-left: 20px; margin-right: 20px;"
      *ngIf="!equipmentSelectionLocked " [@fadeIn]>
      <div class="panel__header">
        <span class="panel__header__title">
          {{  'Select Equipment To Perform Action' | translate | async }}
        </span>
      </div>

      <div class="panel__content no-padding">
        <!-- <div class="col-md-offset-3 col-md-3"> -->
        <form>
          <mat-form-field class="action-input">
            <mat-select (selectionChange)="customerChanged($event)" name="customer" [(ngModel)]="_currentSelection.customer"
              placeholder="{{Translate('Select Customer')}}">
              <mat-option *ngFor="let customer of _dropDownListsFiltered.customerList" [value]="customer">
                {{ customer.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="action-input">
            <mat-select (selectionChange)="jobsiteChanged($event)" name="jobsite" [(ngModel)]="_currentSelection.jobSite"
              placeholder="{{Translate('Select Job Site')}}">
              <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
                {{ jobsite.Title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="action-input">
            <mat-select (selectionChange)="equipmentChanged($event)" name="equipment"
              placeholder="{{Translate('Select Equipment')}}">
              <mat-option *ngFor="let equipment of _dropDownListsFiltered.equipmentList" [value]="equipment">
                {{ equipment.Serial+ ' : ' + equipment.Unit }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </div>
      <!-- </div> -->


      <!-- <div *ngIf="!equipmentSelectionLocked && (equipmentId !== undefined || equipmentId !==0 )"> <mat-spinner></mat-spinner></div> -->
    </div>


    <div class="content" *ngIf="equipmentSelectionLocked">
      <div class="overview">
        <div class="overview__image-container">
          <div class="overview__image" *ngIf="!_loadingEquipment" [@fadeIn]>
            <img [src]="getImage(_selectedEquipment.EquipmentPhoto)" class="equipment-photo" />
          </div>
        </div>
        <div class="overview__content">
          <div class="content__primary">
            <item-group>
              <item [label]="translate('Serial Number')" [primary]="true" [loading]="_loadingEquipment">
                <a routerLink="/equipment/{{equipmentId}}"
                  [matTooltip]="translate('Manage Equipment')">{{ _selectedEquipment.SerialNumber }}</a>
              </item>
              <item [label]="translate('Unit Number')" [primary]="true" [loading]="_loadingEquipment">
                <a routerLink="/equipment/{{equipmentId}}"
                  [matTooltip]="translate('Manage Equipment')">{{ _selectedEquipment.UnitNumber }}</a>
              </item>
              <!--
                <item [label]="translate('Make')" [loading]="overviewIsLoading">{{overviewModel.Equipment.Make}}</item>
                <item [label]="translate('Model')" [loading]="overviewIsLoading">{{overviewModel.Equipment.Model}}</item>
              -->
            </item-group>
            <div class="content__primary-buttons" *ngIf="!_loadingEquipment" [@fadeInList]>
              <button *ngIf="equipmentSelectionLocked" mat-raised-button color="warn" (click)="reSelectEquipment()">
                <mat-icon aria="unlock">lock_open</mat-icon>
                {{ translate("Change Equipment") }}
              </button>
              <!-- <mat-card color="warning" *ngIf="equipmentSelectionLocked">{{Translate('By changing equipment you will lose all your inputs!')}} <button (click)="reSelectEquipment()" mat-icon-button> {{Translate('Unlock')}} <mat-icon aria="unlock">lock_open</mat-icon></button> </mat-card> -->
            </div>
          </div>
          <div class="content__secondary">
            <div class="special">
              <item-group>
                <div>
                  <item [label]="translate('Customer')" [loading]="_loadingEquipment">
                    {{ _selectedEquipment.CustomerName }}</item>
                </div>
                <div>
                  <item [label]="translate('Job Site')" [loading]="_loadingEquipment">
                    {{ _selectedEquipment.JobsiteName }}</item>
                </div>
                <div>
                  <item [label]="translate('Meter Reading (SMU/Hourmeter)')" [loading]="_loadingEquipment">
                    {{ _selectedEquipment.Smu }}</item>
                </div>
                <div>
                  <item [label]="translate('Life to Date (LTD)')" [loading]="_loadingEquipment">
                    {{ _selectedEquipment.Ltd }}</item>
                </div>
                <div>
                  <item [label]="translate('Make')" [loading]="_loadingEquipment">{{ _selectedEquipment.Make }}</item>
                </div>
                <div>
                  <item [label]="translate('Model')" [loading]="_loadingEquipment">{{ _selectedEquipment.Model }}</item>
                </div>
                <div>
                  <item [label]="translate('Family')" [loading]="_loadingEquipment">{{ _selectedEquipment.Family }}
                  </item>
                </div>
                <div></div>
              </item-group>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="fix-control-area">
      {{stepOneErrorMessage}}
      <button style="float: right;" mat-raised-button color="warn" [disabled]='!equipmentSelectionLocked'
        (click)="step0()">{{Translate('Next')}}</button>
    </div>

  </mat-step>
  <mat-step>
    <ng-template matStepLabel>{{   "Select System / Component" | translate | async  }}</ng-template>
    <div class="flex" style="justify-content:space-evenly ;padding: 6px;">
      <button class="systemActionButton mat-raised-button {{selectLeftButton==true?'mat-warn': ''}} " style="width: 15%"
        (click)="selectLeftSide()">
        {{  Translate('Left Side')  }}
      </button>
      <button class="systemActionButton mat-raised-button {{selectRightButton==true?  'mat-warn': ''}} "
        style="width: 15%" (click)="selectRighttSide()">
        {{  Translate('Right Side')  }}
      </button>

    </div>

    <div class="flex" style="justify-content:center ; padding: 6px;" *ngIf="selectLeftButton==true||selectRightButton==true">

      <div style="display: flex; flex-direction: column;     padding: 10px;">
        <label style="align-self: center;">{{sideName | translate | async }} {{  Translate('Chain')  }}</label>
        <button class="systemActionButton mat-raised-button   {{isReplaceNew==true && isReplaceNewChain==true?  'mat-warn': ''}} " style="margin-bottom: 5px" (click)="ReplaceNew(1)">
          {{  Translate('Replace with new Chain and all Components')  }}
        </button>
        <button class="systemActionButton mat-raised-button {{showChain==true && replaceChainSystem==true && isReplaceNew==false  && isReplaceMultiple==false?  'mat-warn': ''}} " style="margin-bottom: 5px" (click)="ReplaceFromInv(1)">
          {{  Translate('Replace with Chain from Inventory')  }}
        </button>
        <button class="systemActionButton mat-raised-button {{showChain==true &&( replaceChainSystem==false && replaceFrameSystem==false)?  'mat-warn': ''}}  " (click)="IndiviualComponentAction(1)">
          {{  Translate('Repairs or Replacements of individual Chain Components')  }}
        </button>
      </div>
      <div style="display: flex; flex-direction: column;   padding: 10px;">
        <label style="align-self: center;">{{sideName| translate | async}} {{  Translate('Frame')  }}</label>
        <button class="systemActionButton mat-raised-button  {{isReplaceNew==true && isReplaceNewFrame==true?  'mat-warn': ''}} " style="margin-bottom: 5px" (click)="ReplaceNew(2)">
          {{  Translate('Replace with New Frame including new components')  }}
        </button>
        <button class="systemActionButton mat-raised-button {{showFrame==true && replaceFrameSystem==true && isReplaceNew==false   && isReplaceMultiple==false?  'mat-warn': ''}}  " style="margin-bottom: 5px" (click)="ReplaceFromInv(2)">
          {{  Translate('Replace frame from Inventory')  }}
        </button>
        <button class="systemActionButton mat-raised-button {{showFrame==true && ( replaceChainSystem==false && replaceFrameSystem==false) ?  'mat-warn': ''}}  " style="margin-bottom: 5px" (click)="IndiviualComponentAction(2)">
          {{  Translate('Repair or Replace individual Frame components')  }}
        </button>
        <button class="systemActionButton mat-raised-button  {{isReplaceMultiple==true?  'mat-warn': ''}} " (click)="MultipleComponent(2)">
          {{  Translate('Replace Frame Components in Bulk')  }}
        </button>
      </div>
    </div>
<div *ngIf="showDiv">
    <div class="flex flex-containers" style="justify-content: center;">

      <div class="panel info-panels "  [class.hide]="(showChain==true && sideName=='Right') || (showFrame==true && sideName=='Left') ||  (showFrame==true && sideName=='Right') " >
        <div>
          <system-actions *ngIf="equipmentSelectionLocked" #LeftChain [side]="1" [systemType]="1" [selectedActionInput]="selectedAction" [selectedActionAgainstSystemInput]="system"
            [equipmentId]="this.equipmentId" (unlockActions)="unlockAction()" [isReplace]="replace"
            (selectedComponentAction)='selectedComponentAction($event, 1,1)' 
            (selectedSystemAction)='selectedSystemAction($event, 1, 1)'  (systemInfoLoaded)="systemLoaded($event,1, 1)" 
           >
          </system-actions>
        </div>
      </div>
     
      <div class="panel  info-panels"  [class.hide]="(showChain==true && sideName=='Left') || (showFrame==true && sideName=='Left') || (showFrame==true && sideName=='Right')">
        <div>
          <system-actions *ngIf="equipmentSelectionLocked" #RightChain [side]="2" [systemType]="1"  [selectedActionInput]="selectedAction" [selectedActionAgainstSystemInput]="system"
            [equipmentId]="this.equipmentId" (unlockActions)="unlockAction()"
            (selectedComponentAction)='selectedComponentAction($event, 2,1)'
            (selectedSystemAction)='selectedSystemAction($event, 2, 1)' (systemInfoLoaded)="systemLoaded($event,1, 2)">
          </system-actions>
        </div>
      </div>
    </div>
    <div class="flex flex-containers" style="justify-content: center;">
      <div class="panel info-panels " [class.hide]="(showChain==true && sideName=='Left') || (showChain==true && sideName=='Right') || (showFrame==true && sideName=='Right')">
        <div>
          <system-actions *ngIf="equipmentSelectionLocked" #LeftFrame [side]="1" [systemType]="2"  [selectedActionInput]="selectedAction" [selectedActionAgainstSystemInput]="system"
            [equipmentId]="this.equipmentId" (unlockActions)="unlockAction()"
            (selectedComponentAction)='selectedComponentAction($event, 1,2)'
            (selectedSystemAction)='selectedSystemAction($event, 1,2)' (systemInfoLoaded)="systemLoaded($event,1, 2)">
          </system-actions>
        </div>
      </div>
      <div class="panel  info-panels" [class.hide]="(showChain==true && sideName=='Left') || (showChain==true && sideName=='Right') || (showFrame==true && sideName=='Left')">
        <div>
          <system-actions *ngIf="equipmentSelectionLocked" #RightFrame [side]="2" [systemType]="2"  [selectedActionInput]="selectedAction" [selectedActionAgainstSystemInput]="system"
            [equipmentId]="this.equipmentId" (unlockActions)="unlockAction()"
            (selectedComponentAction)='selectedComponentAction($event, 2,2)'
            (selectedSystemAction)='selectedSystemAction($event, 2,2)' (systemInfoLoaded)="systemLoaded($event,2, 2)">
          </system-actions>
        </div>
      </div>
    </div>
</div>


    <div class="fix-control-area">
      {{stepTwoErrorMessage}}
      <button style="float: right;" mat-raised-button color="warn" [disabled]='!equipmentSelectionLocked '
        (click)="step1()">{{Translate('Next')}}</button>
      <button style="float: right;" mat-button matStepperPrevious
        (click)="_selectedIndex = 0">{{Translate('Back')}}</button>

    </div>

  </mat-step>



  <mat-step *ngIf="isReplacingMultipleComponentsAtOnce==true">
    <ng-template matStepLabel>{{   "Multiple Component Replacement " | translate | async  }}</ng-template>
    <div *ngIf="selectedSystem !== undefined">
      <create-multiple-system-components #multipleSystemReplacementComponent [selectedEquipment]="_selectedEquipment"
        [systemSide]='selectedSystemSide' [equipmentId]='equipmentId'></create-multiple-system-components>
    </div>
    <div class="fix-control-area">
      {{additionalStepErrorMessage}}
      <button style="float: right;" mat-raised-button color="warn" [class.loading]="_actioning"
        [disabled]='!getMultipleReplacementVaild()' *ngIf="!replacementSucessful"
        (click)="additionalStepNext()">{{Translate('Save')}}</button>
      <button style="float: right;" mat-button matStepperPrevious
        (click)="_selectedIndex = 1">{{Translate('Back')}}</button>


      <button *ngIf="replacementSucessful" mat-raised-button color="warn" style="float: right;" mat-button
        (click)="GoToEquipmentDetails()">{{Translate('View Equipment Details')}}</button>
      <button *ngIf="succesfullySubmitted" mat-raised-button color="warn" style="float: right;" mat-button
        (click)="EnterANewAction()">{{Translate('Enter A New Action')}}</button>

    </div>

  </mat-step>







  <mat-step *ngIf="!isReplacingMultipleComponentsAtOnce">
    <ng-template matStepLabel>{{   "Action Informations" | translate | async  }}</ng-template>
    <!-- {{ ' ' + selectedAction?.ActionTypeName  | translate | async }} {{selectedComponent !== undefined ? ' component' : ' system'  | translate | async  }}
    <div *ngIf= "selectedComponent === undefined">
        System Action
        <div *ngIf="isReplaceAction">
            <mat-icon aria="arrow_downward" style="color: red;">arrow_downward</mat-icon> <mat-icon aria="arrow_upward" style="color: green;">arrow_upward</mat-icon>
        </div>
        <div *ngIf="!isReplaceAction">
            is not Replace action
        </div>
    </div>

    <div *ngIf= "selectedSystem === undefined">
        Component Action
        <div *ngIf="isReplaceAction">
            <mat-icon aria="arrow_downward" style="color: red;">arrow_downward</mat-icon> <mat-icon aria="arrow_upward" style="color: green;">arrow_upward</mat-icon>

          </div>
        <div *ngIf="!isReplaceAction">
            is not Replace action
        </div>
    </div> -->

    <div class="flex flex-containers" [formGroup]="actionForm">

      <div class="panel info-panels" style="width:40%; margin-top:10px; margin-left:10px;">

        <div>
          <div *ngIf="selectedComponent === undefined">
            <div *ngIf="selectedSystem !== undefined" [@fadeIn]>
              <div class="panel__header">
                <span class="panel__header__title">
                  {{ ' ' + selectedAction?.ActionTypeName  | translate | async }}
                  {{selectedComponent !== undefined ? ' component' : ' on system'  | translate | async  }}
                </span>
              </div>
              <div>

                <div *ngIf="availableSystemReplacements?.length > 0">
                  <mat-form-field class="action-input">
                    <mat-select (selectionChange)="selectedSystemReplacement($event)" name="replacement"
                      name="'Select available replacement'" placeholder="{{Translate('Select available replacement')}}">
                      <mat-option *ngFor="let replacement of availableSystemReplacements" [value]="replacement">
                        {{ replacement.SystemSerialNumber }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <span *ngIf="availableSystemReplacements?.length == 0"
                  style=" margin-left: 25px;">{{translate('There are no available replacement in your inventory fits this system, please setup a new one ')}}</span>
                <div style=" margin-left: 25px;" class="content__primary-buttons">
                  <button mat-raised-button color="warn" (click)="setupNewInInventory()">
                    <mat-icon aria="fiber_new">fiber_new</mat-icon>
                     {{ translate("Setup new ") }} 
                    {{  selectedAction?.ActionTypeName =='Replace Chain ' ?'Chain':'Frame'   | translate | async }}
                    {{ translate(" System ") }} 
                  </button>
                  <button mat-raised-button color="warn" (click)="refreshReplacement()">
                    <mat-icon aria="autorenew">autorenew</mat-icon>
                    {{ translate("Refresh Available ") }}
                    {{  selectedAction?.ActionTypeName =='Replace Chain ' ?'Chains':'Frames'   | translate | async }}
                    {{ translate(" in Inventory ") }} 
                  </button>
                </div>
                <!-- <div style=" margin-left: 25px;" class="content__primary-buttons" >

                        </div> -->
              </div>

            </div>

          </div>
          <div *ngIf="selectedSystem === undefined">
            <div *ngIf="selectedComponent !== undefined">
              <div class="panel__header">
                <span class="panel__header__title">
                  {{ ' ' + selectedAction?.ActionTypeName  | translate | async }}
                  {{selectedComponent !== undefined ? ' component' : ' on system'  | translate | async  }}
                </span>
              </div>
              <div *ngIf="availableComponentReplacements?.length === 0 && isReplaceAction">
                {{ translate("There are no available replacements fits this component") }}
              </div>
              <div *ngIf="availableComponentReplacements?.length > 0 && isReplaceAction">
                <mat-form-field class="action-input">
                  <mat-select (selectionChange)="selectedComponentReplacement($event)" name="replacement"
                    name="'Select available replacement'" placeholder="{{Translate('Select available replacement')}}">
                    <mat-option *ngFor="let replacement of availableComponentReplacements" [value]="replacement">
                      {{ replacement.Name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div
                *ngIf="+action.ActionTypeId === 10602 || +action.ActionTypeId === 17 || +action.ActionTypeId === 10702">
                <mat-form-field class="action-input" *ngIf="allRollers?.length >= 1">
                  <mat-select name="Roller To Swap" placeholder="{{'Select Swap component' | translate | async}}">
                    <mat-option *ngFor="let roller of allRollers" (click)="swapRollerEvent(roller)" [value]="roller">
                      {{ roller.Name }} {{ roller.Position }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div style="margin-left: 25px; color: orange;"
                  *ngIf="allRollers?.length <= 1 || allRollers === null || allRollers === undefined">
                  {{'Note : There are not enough same type of rollers to swap position with on this system' | translate | async}}
                </div>
                <!-- <mat-form-field class="action-input">
                        <mat-select (selectionChange)="selectedComponentReplacement($event)"  name="replacement"  name= "'Select available replacement'" placeholder="{{Translate('Select available replacement')}}">
                            <mat-option *ngFor="let replacement of availableComponentReplacements" [value]="replacement">
                                {{ replacement.Name }}
                            </mat-option>
                        </mat-select>
                      </mat-form-field> -->
              </div>
            </div>
          </div>
        </div>
        <div>
          <div>
            <div *ngIf="equipmentSelectionLocked" [@fadeIn]>
              <div class="panel__header">
                <span class="panel__header__title">
                  {{'Please Enter Action Informations' | translate | async}} (  <span style="color: red"> {{'Red are Required Fields'| translate | async}}</span> )
                </span>
                
              </div>
              <div>
                <div *ngIf="isReplaceAction" [@fadeIn]>
                  <!-- <div>
                        <mat-form-field class="input">
                          <mat-select (selectionChange)="replacementCompartChanged($event)" name="action" [(ngModel)]="action.BrandId"
                            placeholder="{{Translate('Compartment')}}">
                            <mat-option *ngFor="let compart of availableCompartments" [value]="action.ReplaceCompartment">
                              {{ compart.Name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div> -->

                  <!-- todo minues vaildation -->
                  <div *ngIf="selectedComponent !== undefined && selectedAction?.ActionTypeId==10802">
                    <mat-form-field class="action-input">
                      <input matInput
                             placeholder="{{'Hours Component Previously Used ' | translate | async}}"
                             type="number" [(ngModel)]="action.Reed" formControlName="ReedControl" min="0" [formControl]="ReedControl" ngDefaultControl>
                    </mat-form-field>

                    <!--<mat-form-field class="action-input" *ngIf="_selectedEquipment.FamilyId==177 || _selectedEquipment.FamilyId==203">-->
                    <mat-form-field class="action-input" *ngIf="_selectedEquipment.ShowPropelHrsPerc">
                      <input matInput
                             placeholder="{{'Propel Hours Component Previously Used ' | translate | async}}"
                             type="number" [(ngModel)]="action.ReedPMU" formControlName="ReedPMUControl" min="0" [formControl]="ReedPMUControl" ngDefaultControl>
                    </mat-form-field>



                  </div>
                  <div *ngIf="selectedComponent !== undefined ">
                    <mat-form-field class="action-input">
                      <input matInput placeholder="{{'Budget Life' | translate | async}}" type="number"
                        [(ngModel)]="action.BudgetLife" formControlName="BudgetLifeControl" min="0" ngDefaultControl [formControl]="BudgetLifeControl" required>
                    </mat-form-field>
                  </div>
                   <div *ngIf="selectedComponent !== undefined">
                    <mat-form-field class="action-input">
                       <!--to do component make -->
                      <!-- <mat-select [(ngModel)]="action.MakeId"  (change)="changeMake($event)"
                      formControlName="MakeControl" placeholder="{{Translate('Brand')}}" [formControl]="MakeControl">
                        <mat-option *ngFor="let make of Makes" [value]="make.Id" >
                          {{ make.Title }}
                        </mat-option>
                      </mat-select> -->

                      <mat-select (selectionChange)="changeMake($event)"
                     placeholder="{{'Brand' | translate | async}} ">
                    <mat-option *ngFor="let make of Makes" [value]="make.Id">
                      {{ make.Title }}
                    </mat-option>
                  </mat-select>
                    </mat-form-field>
                  </div> 

                  
                </div>
              </div>


              <div>
                <mat-form-field class="action-input">
                  <input matInput placeholder="{{'SMU/Hourmeter of Equipment at Action Date' | translate | async}}"
                    type="number" [(ngModel)]="action.NewSMU" formControlName='SMUControl'  required ngDefaultControl [formControl]="SMUControl" autofocus >
                </mat-form-field>
              </div>

              <div>
                <!--<mat-form-field class="action-input" *ngIf="_selectedEquipment.FamilyId==177 || _selectedEquipment.FamilyId==203">-->
                <mat-form-field class="action-input" *ngIf="_selectedEquipment.ShowPropelHrsPerc">
                  <input matInput placeholder="{{'Propel Hours of Equipment at Action Date' | translate | async}}"
                    type="number" [(ngModel)]="action.NewPMU" formControlName='PMUControl'  required ngDefaultControl [formControl]="PMUControl" autofocus >
                </mat-form-field>
              </div>

              <div *ngIf=" +action.ActionTypeId === 10302 || +action.ActionTypeId === 10203">
                <mat-form-field class="action-input">
                  <input matInput placeholder="{{'How long Budget Life will be extended' | translate | async}}"
                    type="number" [(ngModel)]="action.ExtendedBudgetLife" min="0"
                    formControlName='ExtendedBudgetLifeControl'>
                </mat-form-field>
              </div>

              <div>
                  <mat-form-field class="action-input">
                      <span matPrefix>$</span>
                      <input matInput placeholder="{{'Part Cost' | translate | async}}"
                        type="number" [(ngModel)]="action.PartCost" formControlName='PartCostControl' ngDefaultControl [formControl]="PartCostControl" >
                    </mat-form-field>
              </div>
              <div>
                <mat-form-field class="action-input">
                  <!--  -->
                  <mat-select (selectionChange)="labourCostOptionChanged($event)" [(ngModel)]="action.LabourCostOption"
                     placeholder="{{'Labour Cost Option' | translate | async}} ">
                    <mat-option *ngFor="let op of LabourCostOptions" [value]="op.Id">
                      {{ op.Name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div *ngIf="action.LabourCostOption == 1   && cutomerHourlyRate != 0" style="margin-left: 25px;">
                  {{' Customer hourly rate' | translate | async}} : $ {{cutomerHourlyRate}} </div>
                <mat-form-field class="action-input" *ngIf="needToInputHourlyRate && action.LabourCostOption == 1 ">
                  <span matPrefix>$</span>
                  <input matInput placeholder="{{ 'Customer Hourly Rate' | translate | async}}"
                    [(ngModel)]="action.HourlyRate" type="number" min="0" formControlName='HourlyRateControl'> 
                  <!--  -->
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="action-input">
                  <span *ngIf="labourCostLableTitle == 'Labour Cost'" matPrefix>$</span>
                  <input matInput placeholder="{{ labourCostLableTitle | translate | async}}"
                    [(ngModel)]="action.LabourCost" type="number" formControlName='LabourCostControl' min="0">
                  <!---->
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="action-input">
                  <span matPrefix>$</span>
                  <input matInput placeholder="{{'Misc Cost' | translate | async}}" type="number"
                    [(ngModel)]="action.MiscCost" formControlName='MiscCostControl' min="0">
                  <!--  -->
                </mat-form-field>
              </div>
              <div class="action-input"> {{' Total Cost' | translate | async}} : {{currentTotalCost() | currency }}
              </div>
              <div>
                <mat-form-field class="action-input">
                  <input matInput [matDatepicker]="myDatepicker" placeholder="Date of Action"
                    (ngModelChange)="pickedEventDate($event)"
                    min="{{_selectedEquipment?.EquipmentSetupDate | date:'yyyy-MM-dd'}}"
                    max="{{today | date:'yyyy-MM-dd'}}" formControlName="DateControl" readonly
                    (click)="myDatepicker.open()" required >
                  <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
                  <mat-datepicker #myDatepicker></mat-datepicker>
                  <!-- [ngModel]="action.ActionDate"  -->
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="action-input">
                  <textarea matInput placeholder="Comment" [(ngModel)]="action.Comment"(change)="CommentChange($event)"></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      
      </div>


      <div class="panel info-panels " style="width:55%; margin-left: 50px; margin-top:10px;">
        <div>
          <div *ngIf="equipmentSelectionLocked" [@fadeIn]>
            <div class="panel__header">
              <span class="panel__header__title">
              
                {{selectedComponent !== undefined ? ' Action Against Component' : selectedAction?.ActionTypeName =='Replace Chain ' ?'Chain to be Removed':'Frame to be Removed'  | translate | async  }}
                <!-- {{' to be Removed' | translate | async}} -->
               
              </span>
            </div>
            <div style="border: 1px; border-style: solid; border-color: red; margin-left:5px;"
              *ngIf="isReplaceAction   && oldSystemDisplayView !== undefined">
              <system-action-view [system]="oldSystemDisplayView"></system-action-view>
              <div style="margin-top: 15px; margin-left: 20px;">
                {{'Uninstall this at SMU/Hourmeter' | translate | async}} : {{ action.NewSMU }} </div>
              <div style="margin-top: 15px; margin-left: 20px;"
                *ngIf="futureActionsOnOldSystemThatBelongsToNewSystem?.ShouldAllowToPerform">
                {{'This System is  suitable for replacement' | translate | async}} </div>
              <div style="margin-top: 15px; margin-left: 20px;"
                *ngIf="futureActionsOnOldSystemThatBelongsToNewSystem?.ShouldAllowToPerform == false">
                {{'This System is not suitable for replacement due to the following actions' | translate | async}}
              </div>
              <div style="margin-top: 15px; margin-left: 20px;"
                *ngIf="futureActionsOnOldSystemThatBelongsToNewSystem?.ActionsWillBeEffected.length >  0">
                <mat-divider></mat-divider>
                <div>{{'Action Histories will be affected by this action' | translate | async}}</div>
                <mat-table [dataSource]="oldSystemDataSource" style="border: solid; margin: 5px; border-color: yellow;">
                  <ng-container matColumnDef="ActionDate">
                    <mat-header-cell *matHeaderCellDef> {{'Action Date' | translate | async}} </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ActionDate |  date:'yyyy-MM-dd'}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="ActionTypeName">
                    <mat-header-cell *matHeaderCellDef> {{'Action Name' | translate | async}} </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ActionTypeName}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="OldActualLife">
                    <mat-header-cell mat-header-cell *matHeaderCellDef> {{'LTD' | translate | async}} </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.OldActualLife}} </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
              </div>
            </div>
            <div style="border: 1px; border-style: solid; border-color: red;"
              *ngIf="isReplaceAction   && selectedComponent !== undefined">
              <component-action-view [component]="selectedComponent"></component-action-view>
            </div>
            <div *ngIf="!isReplaceAction   && selectedComponent !== undefined">
              <component-action-view [component]="selectedComponent"></component-action-view>
            </div>
          </div>
        </div>

        <div style='text-align: center; margin-top: 20px;' *ngIf="isReplaceAction && selectedSystem !== undefined">
          <mat-icon aria="arrow_downward" style="color: red;">arrow_downward</mat-icon> <span
            style=" margin-left: 20px; margin-right:20px "> {{ 'will be replaced by' | translate | async }} </span>
          <mat-icon aria="arrow_upward" style="color: green;">arrow_upward</mat-icon>
        </div>
        <div *ngIf="isReplaceAction">
          <div>
            <div *ngIf="equipmentSelectionLocked" [@fadeIn]>
              <div class="panel__header" *ngIf="selectedSystem !== undefined">
                <span class="panel__header__title">
                  <!-- {{'New' | translate | async}}
                  {{selectedComponent !== undefined ? ' Component' : ' System'  | translate | async  }} -->

                  {{selectedComponent !== undefined ? ' Component' : selectedAction?.ActionTypeName =='Replace Chain ' ?'Chain ':'Frame'  | translate | async  }}
                  {{' to be Installed' | translate | async}}
                </span>
              </div>
            </div>
            <div style="border: 1px; border-style: solid; border-color: green;"
              *ngIf="newSystemDisplayView !== undefined">
              <system-action-view [system]='newSystemDisplayView'></system-action-view>
              <div style="margin-top: 15px; margin-left: 20px;" *ngIf="futureActionsOnNewSystem?.ShouldAllowToPerform">
                {{'This System is  suitable for replacement' | translate | async}} </div>
              <div style="margin-top: 15px; margin-left: 20px;"
                *ngIf="futureActionsOnNewSystem?.ShouldAllowToPerform == false">
                {{'This System is not suitable for replacement due to the following actions' | translate | async}}
              </div>
              <div style="margin-top: 15px; margin-left: 20px;"
                *ngIf="futureActionsOnNewSystem?.ActionsWillBeEffected.length >  0">
                <mat-divider></mat-divider>
                <div>{{'Action Histories and Inspections will be affected by this action' | translate | async}}</div>
                <mat-table [dataSource]="newSystemDataSource" style="border: solid; margin: 5px; border-color: yellow;">
                  <ng-container matColumnDef="ActionDate">
                    <mat-header-cell *matHeaderCellDef> Action Date </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ActionDate  | date:'yyyy-MM-dd'}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="ActionTypeName">
                    <mat-header-cell *matHeaderCellDef> ActionName </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.ActionTypeName}} </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="OldActualLife">
                    <mat-header-cell mat-header-cell *matHeaderCellDef> SMU/HourMeter </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.OldActualLife}} </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
              </div>
            </div>
            <div style="border: 1px; border-style: solid; border-color: green;" *ngIf="newComponentView !== undefined">
              <div></div>
            </div>
            <div *ngIf="newSystemDisplayView === undefined && selectedComponent === undefined " style="border: 1px; border-style: solid; border-color: red; min-height: 100px;">
              {{' Please select a '| translate | async}}
              {{selectedComponent !== undefined ? ' Component' : selectedAction?.ActionTypeName =='Replace Chain ' ?'Chain ':'Frame'  | translate | async  }}
              {{' from inventory or setup a new ' | translate | async}}
              {{selectedComponent !== undefined ? ' Component' : selectedAction?.ActionTypeName =='Replace Chain ' ?'Chain ':'Frame'  | translate | async  }}
            </div>
            <div *ngIf="selectedComponent === undefined && selectedComponent !== undefined">
              {{' Please select a replace component in the drop down list '| translate | async}}
            </div>

          </div>
        </div>
      </div>




    </div>
    <div class="fix-control-area">
      <button style="float: right;" mat-raised-button color="warn" [class.loading]="_actioning"
        *ngIf="!succesfullySubmitted" [disabled]="saveActionVaild()"
        (click)="saveAction()">{{Translate('Save Action')}}</button>

      <button mat-raised-button color="warn" style="float: right;" mat-button matStepperPrevious
        (click)="_selectedIndex = 1">{{Translate('Back')}}</button>




      <button *ngIf="succesfullySubmitted" mat-raised-button color="warn" style="float: right;" mat-button
        (click)="GoToEquipmentDetails()">{{Translate('View Equipment Details')}}</button>
      <button *ngIf="succesfullySubmitted" mat-raised-button color="warn" style="float: right;" mat-button
        (click)="EnterANewAction()">{{Translate('Enter A New Action')}}</button>

      <!-- isReplaceAction &&  -->
      <!-- <button mat-raised-button color="warn" [disabled]="()isReplaceAction && !futureActionsOnOldSystemThatBelongsToNewSystem?.ShouldAllowToPerform && !futureActionsOnNewSystem?.ShouldAllowToPerform " (click)="saveAction()">{{Translate('Save Action')}}</button> -->
    </div>

  </mat-step>
</mat-horizontal-stepper>
